import { setDeactivatedUsersList, setDeactivatedUsersRowCount } from '@/store';
import { DEACTIVATED_USERS_LIST_TAG } from '../constants';
import { api } from '../core';

export interface DeactivatedUserData {
  createdAt: string;
  deactivatedAt: string;
  userEmail: string;
  userId: string;
  userName: string;
  userRole: string; // UI adopted UserRoleType;
}

export interface GetDeactivatedUsersResponse {
  numberOfResults: number;
  users: DeactivatedUserData[];
}

export interface GetDeactivatedUsersRequest {
  pageIndex: number;
  pageSize: number;
  name?: string;
}

const getDeactivatedUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDeactivatedUsers: builder.query<GetDeactivatedUsersResponse, GetDeactivatedUsersRequest>({
      query: ({ pageIndex, pageSize, name }: GetDeactivatedUsersRequest) => ({
        url: `users/deactivated`,
        method: 'GET',
        params: { pageIndex: pageIndex, pageSize: pageSize, name: name }
      }),
      providesTags: (_result, _error, { pageIndex, pageSize }) => [
        { type: DEACTIVATED_USERS_LIST_TAG, id: `${pageIndex}-${pageSize}` }
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setDeactivatedUsersList(data.users));
            dispatch(setDeactivatedUsersRowCount(data.numberOfResults));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getDeactivatedUsers in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 3 },
      keepUnusedDataFor: 0
    })
  })
});

export const { useLazyGetDeactivatedUsersQuery } = getDeactivatedUsersApi;
